module.exports = __webpack_public_path__ + "img/ios-trophy.18ebe495.svg";